module.exports = __webpack_public_path__ + "static/media/hiw10.fa0cd8e7.svg";